import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_CUSTOMERS } from "../../../utils/constants";
import { CustomerInterface } from "../../../models/TicketModule/Customer";
import customerService from "../../../services/ticketService/customerService";

const useCustomers = (page: number, pageSize: number) =>
  useQuery<CustomerInterface[], Error>({
    queryKey: [
      CACHE_KEY_CUSTOMERS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => customerService.GetAll(page, pageSize),
  });

export default useCustomers;
